import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NavParams, ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { CheckerValue, FilterProps, FilterQuery } from 'src/app/interfaces/helpers';
import { FunctionsService } from 'src/app/services/functions/functions.service';
import { InstallationsManagerService } from 'src/app/services/installations-manager/installations-manager.service';
import { InstallationsService } from 'src/app/services/installations/installations.service';
import { UsersService } from 'src/app/services/users/users.service';

@Component({
  selector: 'app-report-filters-mobile',
  templateUrl: './report-filters-mobile.page.html',
  styleUrls: ['./report-filters-mobile.page.scss'],
})
export class ReportFiltersMobilePage implements OnInit {
  filters: FilterProps;

  searchData: {
    startDate: any,
    finalDate: any,
    collection: any,
    limit: any
  } = {
      startDate: new FormControl('', Validators.compose([Validators.required])),
      finalDate: new FormControl('', Validators.compose([Validators.required])),
      collection: new FormControl('', Validators.compose([Validators.required])),
      limit: new FormControl('', Validators.compose([Validators.required]))
    };

  searchForm: FormGroup;
  limits = [50, 100, 200, 400, 'Por dia'];

  constructor(
    public formBuilder: FormBuilder,
    private funcServ: FunctionsService,
    private navParams: NavParams,
    private installationServ: InstallationsService,
    private managerServ: InstallationsManagerService,
    private userServ: UsersService,
    public modalCtrl: ModalController) { }

  ngOnInit() {
    this.filters = this.navParams.get('filters');
  //  // console.log(this.filters);

  //  // console.log(this.filters);
    this._buildForm();
  }

  _buildForm() {
    const group: any = {
      startDate: this.searchData.startDate,
      finalDate: this.searchData.finalDate,
      collection: this.searchData.collection,
      limit: this.searchData.limit,
    };

    this.searchForm = this.formBuilder.group(group);
    this.searchForm.controls.startDate.setValue(this.funcServ.getDateN(false, -1, true));
    this.searchForm.controls.finalDate.setValue(this.funcServ.getDateN(false, 0, false));
    this.searchForm.controls.limit.setValue(50);
    if (this.filters.checkers) {
      this.filters.checkers.forEach(c => {
        this.searchForm.addControl(c.key, new FormControl());
      });
    }
    if (this.filters.selectables) {
      this.filters.selectables.forEach(s => {
        this.searchForm.addControl(s.key, new FormControl());
      });
    }
  }

  searchCollection(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    
    const text = event['text'].trim().toLowerCase();
    event.component.startSearch();

    if (!text) {
      // Close any running subscription.
      event.component.items = [];
      event.component.endSearch();
      return;
    }

    if (this.filters.collection.label === 'Privada') {
      this.installationServ.filterInstallations(text).subscribe(res => {
        // console.log(res);
        this.filters.collection.collection = res;
        event.component.items = res;
        event.component.endSearch();
      });
    } else if (this.filters.collection.label === 'Usuario') {
      this.userServ.filterUsers(text).then(res => {
        // console.log(res);
        this.filters.collection.collection = res;
        event.component.items = res;
        event.component.endSearch();
      });
    } else if (this.filters.collection.label === 'Asociado') {
      this.managerServ.filterBusiness(text).subscribe(res => {
        this.filters.collection.collection = res;
        event.component.items = res;
        event.component.endSearch();
      });
    }
  }

  getQuery() {
    const checkers: CheckerValue[] = [];
    const selects: string[] = [];
  //  // console.log(this.searchForm.controls['startDate'].value);
  //  // console.log(this.searchForm.controls['finalDate'].value);
    if (this.filters.checkers) {
      this.filters.checkers.forEach(c => {
      //  // console.log(this.searchForm.controls[c.key].value);
        checkers.push({ key: c.key, data: this.searchForm.controls[c.key].value });
      });
    }
    if (this.filters.selectables) {
      this.filters.selectables.forEach(s => {
      //  // console.log(this.searchForm.controls[s.key].value);
        selects.push(this.searchForm.controls[s.key].value);
      });
    }

    const query: FilterQuery = {
      dateStart: this.searchForm.controls.startDate.value,
      dateFinal: this.searchForm.controls.finalDate.value,
      id: this.searchForm.controls.collection.value.id,
      limit: this.searchForm.controls.limit.value,
      checkersValue: checkers,
      selectableValue: selects
    };
    this.modalCtrl.dismiss(query);
  }

  onSelect(event: {
    component: IonicSelectableComponent,
    item: any,
    isSelected: boolean
  }) {
  //  // console.log(event);

    if (event.isSelected) {
      if (!event.item.name) {
        event.item.name = event.item.displayName ? event.item.displayName : event.item.firstName + ' ' + event.item.Lastname;
      }

    }
  }

}
